/**
 * Created by pmacko on 08.07.2016.
 */
/// <reference path="../jsrender/jsrender.d.ts" />

class BasketNotification
{
    public static setLoading(changeMade: boolean)
    {
        let ddl = $('.basket-quickview-wrapper');
        ddl.html('');
        ddl.append($.templates("#basket-items-loading-template").render());
    }

    public static notify(changeMade: boolean)
    {
        let basket:Basket = Basket.instance();

        let ddl = $('.basket-quickview-wrapper');
        ddl.html('');
        ddl.append($.templates("#basket-quickview-template").render());

        $('.basket-total-price').text(basket.price.toFixed(2));
        $('.basket-total-products').text(basket.productsCount);

        $('.basket-dropdown-items').html($.templates("#basket-items-loading-template").render());

        BasketNotification.notifyTopBarBasket(basket, changeMade);

        $('.basket-item').each(function() {
            let el:JQuery = $(this);
            let key:string = $(el).find('.product-guid').val();

            if(key in basket.items)
            {
                let product:BasketItemAjaxResponse = basket.items[key];
                el.find('.basket-item-total-price').text(product.price.toFixed(2));
            }
            else
            {
                el.remove();
            }
        });
    }

    private static notifyTopBarBasket(basket:Basket, changeMade: boolean)
    {
        let ddl = $('.basket-dropdown-items');
        ddl.html('');

        let count = 0;
        for(let i in basket.items)
        {
            count++;
            let text = $.templates("#basket-item-menu-template").render(basket.items[i]);
            ddl.append(text);
        }
        ddl.append($.templates("#basket-items-footer-template").render());

        if(count > 0)
        {
            $('.basket-side-dropdown').show();
        }
        else
        {
            $('.basket-side-dropdown').hide();
        }

        if(changeMade)
        {
            $('.basket-icon').addClass('basket-icon-rotate');
            setTimeout(function(){$('.basket-icon').removeClass('basket-icon-rotate')}, 2000);

            $(".basket-dropdown > a").trigger('click.bs.dropdown');
        }
    }
}